import { Button, dialog } from "nq-component";
import BaseFormPresenter from "../../../../../../components/common/BaseFormPresenter";
import {
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import { CreditsDeduction } from "../../../../../../components/common/Converter";
import { createNotification } from "../../../../../../createNotification";

class LeaveTableFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  getDurationFormula(startdate, enddate) {
    const startDate = new Date(startdate);
    const endDate = new Date(enddate);

    // Calculate the difference in milliseconds
    const differenceInMs = endDate - startDate + 1;

    if (differenceInMs) {
      // Convert milliseconds to days
      const differenceInDays =
        Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1;

      return `${differenceInDays} Day/s`;
    } else {
      return "";
    }
  }

  // leaveWithoutPayDeduction(remainingCredits, lengthCount, startCycle) {
  //   const standardDeduction = 0.021;
  //   const specialDeductions = {
  //     2: 0.02,
  //     8: 0.02,
  //     14: 0.02,
  //     20: 0.02,
  //     27: 0.02,
  //     33: 0.02,
  //     39: 0.02,
  //     45: 0.02,
  //     51: 0.02,
  //     57: 0.02,
  //   };

  //   for (let day = startCycle; day < startCycle + lengthCount; day++) {
  //     // Calculate the equivalent day within a 1–60 range
  //     let cycleDay = ((day - 1) % 30) + 1;

  //     // Apply deduction based on the cycle day
  //     if (specialDeductions[cycleDay]) {
  //       remainingCredits -= specialDeductions[cycleDay]; // Apply special rate
  //     } else {
  //       remainingCredits -= standardDeduction; // Apply standard rate
  //     }
  //   }
  //   return remainingCredits.toFixed(3); // Return final remaining credits, rounded to 3 decimal places
  // }

  DialogConfirmation(status) {
    this.view
      .showConfirmDialog("Click Confirm to continue!", "Confirm", "Confirm")
      .then(() => this.submitData(status))
      .catch(() => {});
  }

  async submitData(status) {
    const { stats, acl, leaveType, employee, duration, ...rest } =
      this.view.state.object;
    const approveDuration = this.getDurationFormula(
      this.view.state.object.startdate,
      this.view.state.object.enddate,
    );

    const approved = status === "Recommending for Approval" ? true : false;
    const submitData = {
      stats: status,
      forApproval: approved,
      selectedType: leaveType.name,
      leaveType: { id: leaveType.id },
      employee: { id: employee.id },
      id: this.view.getObjectId(),
      duration: approveDuration,
      ...rest,
    };

    await upsertUseCase().execute("leave_request", submitData);
    const NOTIFICATION_MESSAGE = "Your Leave Request has been approved!";
    const NOTIFICATION_RECEIVER = [submitData.createdBy.id];
    const NOTIFICATION_REDIRECT = "lmanagement";

    createNotification(
      NOTIFICATION_MESSAGE,
      NOTIFICATION_RECEIVER,
      NOTIFICATION_REDIRECT,
    );
    dialog.close();
    this.showSuccess("Success");
    return;
  }

  async CTOOvertimerequestDeduction(creditDeduct, currentCredits, submitData) {
    if (currentCredits.length === 0) {
      this.showError("Insufficient Credits");
      return;
    }
    const ctoCredit = currentCredits[0];
    // currentCredits.find(
    //   (item) => item.type === "Compensatory Time Off"
    // );

    console.log("CURRENT: ", ctoCredit);
    if (
      parseFloat(ctoCredit.current) >= creditDeduct &&
      currentCredits.length > 0
    ) {
      const current = parseFloat(ctoCredit.current) - creditDeduct;
      ctoCredit.current = current.toFixed(3);
      await upsertUseCase().execute("leave_request", submitData);
      await upsertUseCase().execute("leave_cred", ctoCredit);
      dialog.close();
      this.showSuccess("Successfully Approved");
    } else {
      this.showError("Insufficient Credits");
    }
  }
}

export default LeaveTableFormPresenter;
